import {
  IconButton,
  IconButtonProps,
  IconName,
  Option,
  OptionList,
  Popover
} from "@introist/react-foundation/v2";
import { useState } from "react";

export type IconButtonSelectProps = IconButtonProps & {
  onChange: (value: string) => void;
  options: Option[];
  icon: IconName;
  onClose?: () => unknown;
};

export const IconButtonSelect = ({
  onChange,
  options,
  icon,
  onClose,
  ...rest
}: IconButtonSelectProps) => {
  const [ref, setRef] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  return (
    <div ref={setRef}>
      <IconButton
        icon={icon}
        size="large"
        variant="outlined"
        onClick={() => setOpen(true)}
        {...rest}
      />
      <Popover
        referenceElement={ref}
        onClose={() => {
          setOpen(false);
          onClose && onClose();
        }}
        open={open}
      >
        <OptionList
          options={options}
          onItemClick={({ key }) => {
            onChange(key);
            setOpen(false);
          }}
        />
      </Popover>
    </div>
  );
};
